import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import * as React from 'react';

/**
 * Enter�L�[������TextField
 * @param myProps
 */
const TextFieldNoSubmit: React.FC<TextFieldProps> = myProps => {
	const textFieldProps = { ...myProps };
	textFieldProps.onKeyDown = (event: any) => {
		if (event.keyCode === 13) {
			if (event.preventDefault) {
				event.preventDefault();
			} else {
				event.returnValue = false;
			}
		}
	};

	return <TextField {...textFieldProps} />;
};

export default TextFieldNoSubmit;
export type TextFieldProps = TextFieldProps;



// WEBPACK FOOTER //
// ./src/components/TextFieldNoSubmit.tsx